import React from 'react'
import Container from 'react-bootstrap/esm/Container'
import Card from 'react-bootstrap/esm/Card'
import CardHeader from 'react-bootstrap/esm/CardHeader'
import Col from 'react-bootstrap/esm/Col'
import Row from 'react-bootstrap/esm/Row'
import {get_server_url} from '../variables'
import ActivityEntry from './ActivityEntry'
import LockerRoom from './LockerRoom'
import Sponsor from './Sponsor'
import {CardBody} from 'react-bootstrap'
import {FIELD_TYPES} from '../types'
import {isRunning, splitTeams} from '../match'
import VersusIntro from './VersusIntro'

// How long each half of the left column stays on screen before shifting, at
// least. When it overflows it also waits until it has scrolled down and back up.
const LEFT_COLUMN_INTERVAL = 15000
const SHIFT_CHECK = 500

// Auto scroll of overflowing columns: 1px every 20ms (50px/s), pausing at each end.
const SCROLL_STEP = 1
const SCROLL_TICK = 20
const SCROLL_PAUSE = 4000
// The hall column rests longer at the top, where the running games are.
const HALL_TOP_PAUSE = 10000

// Scrolls the element down, pauses at the bottom, scrolls back up and pauses
// at the top (topPause, defaults to the same as the bottom). The position is tracked here instead of read back from
// scrollTop, which can be fractional and never exactly hit the bottom.
// getElement is called on every tick, so it survives the element remounting.
// isCycleDone() is true once it has been all the way down and back up since
// the last reset, or straight away when everything fits.
function autoScroll(getElement, topPause = SCROLL_PAUSE)
{
	let position = 0
	let direction = 1
	let pauseLeft = topPause
	let cycleDone = false

	const reset = () =>
	{
		position = 0
		direction = 1
		pauseLeft = topPause
		cycleDone = false
		const element = getElement()
		if (element)
		{
			element.scrollTop = 0
		}
	}

	const interval = setInterval(() =>
	{
		const element = getElement()
		if (!element)
		{
			return
		}

		const maxScroll = element.scrollHeight - element.clientHeight
		if (maxScroll <= 0)
		{
			// Everything fits, start from the top when it overflows again.
			position = 0
			direction = 1
			element.scrollTop = 0
			cycleDone = true
			return
		}

		if (pauseLeft > 0)
		{
			pauseLeft -= SCROLL_TICK
			return
		}

		position = Math.min(Math.max(position + direction * SCROLL_STEP, 0), maxScroll)
		element.scrollTop = position

		if (direction === 1 && position >= maxScroll)
		{
			direction = -1
			pauseLeft = SCROLL_PAUSE
		}
		else if (direction === -1 && position <= 0)
		{
			direction = 1
			pauseLeft = topPause
			cycleDone = true
		}
	}, SCROLL_TICK)

	return {reset, isCycleDone: () => cycleDone, stop: () => clearInterval(interval)}
}

function emptyFieldEntries()
{
	const entries = {}
	Object.keys(FIELD_TYPES).forEach((type) => entries[type] = [])
	return entries
}

class Activity extends React.Component	
{
	constructor(props)
	{
		super(props)
		this.state = {
			anyLockerRoom: false,
			entriesRunning: [],
			entriesEvent: '',
			entriesMeating: '',
			entriesLockerRoom: {
				'sundthus': [],
				'jysk':	[],
				'jjd':	[],
				'ojm':	[],
				'bms':	[],
				'vb':	[],
				'dom': [],
				'hom': [],
			},
			entriesKultur: '',
			fullscreenEntry: null,
			entriesField: emptyFieldEntries(),
			showFields: false,
			introQueue: [],
		}
		this.hallRef = React.createRef()
		this.lockerRoomsRef = React.createRef()
	}
	translatePlace(type)
	{
		const map = {
			'sundthus': 'SundtHus',
			'jysk':	'Jysk',
			'jjd':	'JJD',
			'ojm':	'O. Jacobsen Maskinfabrik',
			'bms':	'BM Silo',
			'vb':	'Vestjysk Bank',
			'dom': 'Dameomklædning i kælderen',
			'hom': 'Herreomklædning i kælderen',
		}
		return map[type]
	}
	getActiveActivities()
	{
		var event = []
		var running = []
		var meating = []
		var lockerRoom = {
			'sundthus': [],
			'jysk':	[],
			'jjd':	[],
			'ojm':	[],
			'bms':	[],
			'vb':	[],
			'dom': [],
			'hom': [],
		}
		var kultur = []
		var field = emptyFieldEntries()
		fetch(get_server_url()+'/?cmd=get&active=true', {
			method: 'GET', // *GET, POST, PUT, DELETE, etc.
			cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
			mode: 'cors',
			headers: {
				'Content-Type': 'application/json',
			},
			redirect: 'follow', // manual, *follow, error
		})
			.then(response => response.json())
			.then(result =>
			{
				let any_locker_room = false
				let fullscreenEntry = null

				for (let i = 0; i < result.length; i++)
				{	
					const entry = result[i]
					
					// Check for fullscreen entries first
					if (entry.fullsize) 
					{
						fullscreenEntry = entry
						break // Stop processing other entries if we have a fullscreen one
					}
					
					let first_event = true
					let first_locker_room = true
					let first_culture = true
					let first_field = true
					switch (entry.type)
					{
						case 1: case '1': case 2: case '2':
							(isRunning(entry) ? running : event).push(<ActivityEntry key={entry.id} json={entry} first={first_event} />)
							first_event = false
							break

						case 4: case '4':
							kultur.push(<ActivityEntry key={entry.id} json={entry} first={first_culture} />)
							first_culture = false
							break

						case 3: case '3':
							lockerRoom[entry['eventPlace']].push(<LockerRoom key={entry.id} json={entry} first={first_locker_room} />)
							first_locker_room = false
							any_locker_room = true
							break
						default:
							// The fodboldbaner, and any field added to FIELD_TYPES later.
							if (FIELD_TYPES[entry.type] !== undefined)
							{
								field[entry.type].push(<ActivityEntry key={entry.id} json={entry} first={first_field} />)
								first_field = false
							}
							break
					}
				}

				this.hallMatches = result.filter((entry) => ['1', '2', 1, 2].includes(entry.type) && splitTeams(entry))
				this.checkStartedMatches()

				this.setState(
					{
						anyLockerRoom: any_locker_room,
						entriesRunning: running,
						entriesEvent: event,
						entriesMeating: meating,
						entriesLockerRoom: lockerRoom,
						entriesKultur: kultur,
						fullscreenEntry: fullscreenEntry,
						entriesField: field,
					},
				)
			})
	}

	componentDidMount()
	{
		window.setInterval(() => this.getActiveActivities(), 30000)
		this.getActiveActivities()
		document.querySelector('body').style.overflow = 'hidden'
		this.hallScroller = autoScroll(() => this.hallRef.current, HALL_TOP_PAUSE)
		this.lockerRoomsScroller = autoScroll(() => this.lockerRoomsRef.current)

		// Counted in ticks rather than with Date.now(), like the scroller.
		this.shownFor = 0
		this.shiftInterval = setInterval(() =>
		{
			this.checkStartedMatches()
			this.shownFor += SHIFT_CHECK
			if (this.shownFor >= LEFT_COLUMN_INTERVAL && this.hallScroller.isCycleDone())
			{
				this.shownFor = 0
				this.hallScroller.reset()
				this.setState((state) => ({showFields: !state.showFields}))
			}
		}, SHIFT_CHECK)
	}

	// Queues the versus intro for every match that has just started. Matches
	// already running when the page loads are only remembered, so a reload does
	// not replay them. ?intro (or ?intro=2) plays it for the first match(es) on
	// the list straight away, for testing.
	checkStartedMatches()
	{
		if (!this.hallMatches)
		{
			return
		}

		const firstCheck = this.seenRunning === undefined
		if (firstCheck)
		{
			this.seenRunning = new Set()
		}

		const started = this.hallMatches.filter((entry) => isRunning(entry) && !this.seenRunning.has(entry.id))
		started.forEach((entry) => this.seenRunning.add(entry.id))

		let queue = firstCheck ? [] : started
		if (firstCheck && !this.introTested)
		{
			this.introTested = true
			const test = new URLSearchParams(window.location.search).get('intro')
			if (test !== null)
			{
				queue = this.hallMatches.slice(0, parseInt(test) || 1)
			}
		}

		if (queue.length > 0)
		{
			this.setState((state) => ({introQueue: [...state.introQueue, ...queue]}))
			// Move the started matches up among the running ones right away.
			if (!firstCheck)
			{
				this.getActiveActivities()
			}
		}
	}

	componentDidUpdate()
	{
		// Start from the top every time the left column shifts.
		const showFields = this.isShowingFields()
		if (showFields !== this.lastShowFields)
		{
			this.lastShowFields = showFields
			this.hallScroller.reset()
		}
	}

	componentWillUnmount()
	{
		clearInterval(this.shiftInterval)
		this.hallScroller.stop()
		this.lockerRoomsScroller.stop()
	}

	// The left side shifts between hallen/kultursalen and the outdoor fields,
	// but only shifts when both have something to show. With nothing booked
	// anywhere it falls back to the hallen card.
	isShowingFields()
	{
		const anyField = Object.keys(this.state.entriesField)
			.some((type) => this.state.entriesField[type].length > 0)
		const anyHall = this.state.entriesRunning.length > 0 || this.state.entriesEvent.length > 0 || this.state.entriesKultur.length > 0

		return anyField && (this.state.showFields || !anyHall)
	}

	renderHall()
	{
		return (
			<React.Fragment>
				{/* The header and the running games stay put, only the rest scrolls. */}
				<Card style={{'marginBottom': '10px'}} className="hall-header">
					<CardBody className="column-header">
						<h1>Hallen</h1>
					</CardBody>
				</Card>
				<div className="hall-running">{this.state.entriesRunning}</div>
				<div className="hall-scroll" ref={this.hallRef}>
					{this.state.entriesEvent}

					<Card
						style={{'marginBottom': '10px'}}
						className={(this.state.entriesKultur.length === 0 ? 'd-none' : '')}>
						<CardBody className="column-header">
							<h1>Kultursalen</h1>
						</CardBody>
					</Card>
					{this.state.entriesKultur}
				</div>
			</React.Fragment>
		)
	}
	renderFields()
	{
		return (
			<div className="hall-scroll" ref={this.hallRef}>
				{this.renderFieldList()}
			</div>
		)
	}
	renderFieldList()
	{
		return Object.keys(FIELD_TYPES).map((type) => (
			<React.Fragment key={type}>
				<Card
					style={{'marginBottom': '10px'}}
					className={(this.state.entriesField[type].length === 0 ? 'd-none' : '')}>
					<CardBody className="column-header">
						<h1>{FIELD_TYPES[type]}</h1>
					</CardBody>
				</Card>
				{this.state.entriesField[type]}
			</React.Fragment>
		))
	}
	render()
	{
		// If we have a fullscreen entry, show only that
		if (this.state.fullscreenEntry)
		{
			return (
				<div className="fullscreen-entry">
					<Container fluid style={{height: '100vh', display: 'flex', flexDirection: 'column'}}>
						<Row style={{flex: '1', alignItems: 'center', justifyContent: 'center'}}>
							<Col className="text-center">
								<Card style={{border: 'none', backgroundColor: 'white', borderRadius: '15px', boxShadow: '0 4px 8px rgba(0,0,0,0.1)'}}>
									<CardBody>
										<h1 style={{fontSize: '120px', fontWeight: 'bold', marginBottom: '30px'}}>
											{this.state.fullscreenEntry.eventName}
										</h1>
										{this.state.fullscreenEntry.subEventName && (
											<h2 style={{fontSize: '80px', color: '#6c757d'}}>
												{this.state.fullscreenEntry.subEventName}
											</h2>
										)}
									</CardBody>
								</Card>
							</Col>
						</Row>
					</Container>
					<Sponsor />
				</div>
			)
		}

		// Normal layout when no fullscreen entries
		const showFields = this.isShowingFields()

		return (
			<div>
				<Container fluid className="entries">
					<Row>
						<Col className="hallen" xs={(this.state.anyLockerRoom ? 7 : 12)}>
							{/* The key restarts the css animation every time the column shifts. */}
							<div
								key={showFields ? 'fields' : 'hall'}
								className={'shifting-column ' + (showFields ? 'from-right' : 'from-left')}>
								{showFields ? this.renderFields() : this.renderHall()}
							</div>
						</Col>

						<Col id={'lockerRooms'} xs={(this.state.anyLockerRoom ? 5 : 0)} className={(this.state.anyLockerRoom ? '' : 'd-none')}>
							<Row>
								<Col className="omklaedning" xs={12}>
									<Card style={{marginBottom: '10px'}}>
										<CardBody className="column-header">
											<h1>Omklædning</h1>
										</CardBody>
									</Card>
									<div className="omklaedning-entries" ref={this.lockerRoomsRef}>
										{Object.keys(this.state.entriesLockerRoom).map((key) => (
											<Card className={(this.state.entriesLockerRoom[key].length === 0 ? 'd-none' : '')} key={key}>
												<CardHeader className={'pb-0'}>
													<h2 className={'mb-0'}>{this.translatePlace(key)}</h2>
												</CardHeader>
												<CardBody>
													{this.state.entriesLockerRoom[key]}
												</CardBody>
											</Card>
										))}
									</div>
								</Col>
							</Row>
						</Col>

					</Row>
				</Container>
				<Sponsor />

				{this.state.introQueue.length > 0 && (
					<VersusIntro
						key={this.state.introQueue[0].id}
						json={this.state.introQueue[0]}
						onDone={() => this.setState((state) => ({introQueue: state.introQueue.slice(1)}))} />
				)}
			</div>
		)
	}
}
/**
 * 
 * 
 * 'sundthus': 'SundtHus',
			'jysk':	'Jysk',
			'jjd':	'JJD',
			'ojm':	'O. Jacobsen Maskinfabrik',
			'bms':	'BM Silo',
			'vb':	'Vestjysk Bank',
			'dom': 'Dameomklædning i kælderen',
			'hom': 'Herreomklædning i kælderen',
 */

export default Activity
